/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateWorkflowRequest } from '../model/createWorkflowRequest';
import { DuplicateHybridRequest } from '../model/duplicateHybridRequest';
import { DuplicateRequest } from '../model/duplicateRequest';
import { MyCheckFeatureProposal } from '../model/myCheckFeatureProposal';
import { MyCheckFeatureProposalRequest } from '../model/myCheckFeatureProposalRequest';
import { MyCheckFeatureRequestRequest } from '../model/myCheckFeatureRequestRequest';
import { MyCheckUsage } from '../model/myCheckUsage';
import { ReferencedRulesetDto } from '../model/referencedRulesetDto';
import { SharedMyCheckDto } from '../model/sharedMyCheckDto';
import { WorkflowDefinition } from '../model/workflowDefinition';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class WorkflowDefinitionControllerService {

    protected basePath = 'https://api.beta.planbic.de';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param id 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public activateDefinition(id: string, projectId: number, observe?: 'body', reportProgress?: boolean): Observable<WorkflowDefinition>;
    public activateDefinition(id: string, projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WorkflowDefinition>>;
    public activateDefinition(id: string, projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WorkflowDefinition>>;
    public activateDefinition(id: string, projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling activateDefinition.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling activateDefinition.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<WorkflowDefinition>('post',`${this.basePath}/workflows/definitions/${encodeURIComponent(String(id))}/activate`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createDefinition(body: CreateWorkflowRequest, projectId: number, observe?: 'body', reportProgress?: boolean): Observable<WorkflowDefinition>;
    public createDefinition(body: CreateWorkflowRequest, projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WorkflowDefinition>>;
    public createDefinition(body: CreateWorkflowRequest, projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WorkflowDefinition>>;
    public createDefinition(body: CreateWorkflowRequest, projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createDefinition.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling createDefinition.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<WorkflowDefinition>('post',`${this.basePath}/workflows/definitions`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deactivateDefinition(id: string, projectId: number, observe?: 'body', reportProgress?: boolean): Observable<WorkflowDefinition>;
    public deactivateDefinition(id: string, projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WorkflowDefinition>>;
    public deactivateDefinition(id: string, projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WorkflowDefinition>>;
    public deactivateDefinition(id: string, projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deactivateDefinition.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling deactivateDefinition.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<WorkflowDefinition>('post',`${this.basePath}/workflows/definitions/${encodeURIComponent(String(id))}/deactivate`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param projectId 
     * @param removeShares 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteDefinition(id: string, projectId: number, removeShares?: boolean, observe?: 'body', reportProgress?: boolean): Observable<{ [key: string]: string; }>;
    public deleteDefinition(id: string, projectId: number, removeShares?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<{ [key: string]: string; }>>;
    public deleteDefinition(id: string, projectId: number, removeShares?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<{ [key: string]: string; }>>;
    public deleteDefinition(id: string, projectId: number, removeShares?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteDefinition.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling deleteDefinition.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }
        if (removeShares !== undefined && removeShares !== null) {
            queryParameters = queryParameters.set('removeShares', <any>removeShares);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<{ [key: string]: string; }>('delete',`${this.basePath}/workflows/definitions/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param projectId 
     * @param id 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public duplicateDefinition(projectId: number, id: string, body?: DuplicateRequest, observe?: 'body', reportProgress?: boolean): Observable<WorkflowDefinition>;
    public duplicateDefinition(projectId: number, id: string, body?: DuplicateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WorkflowDefinition>>;
    public duplicateDefinition(projectId: number, id: string, body?: DuplicateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WorkflowDefinition>>;
    public duplicateDefinition(projectId: number, id: string, body?: DuplicateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling duplicateDefinition.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling duplicateDefinition.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<WorkflowDefinition>('post',`${this.basePath}/workflows/definitions/${encodeURIComponent(String(id))}/duplicate`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param projectId 
     * @param id 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public duplicateHybridRuleset(projectId: number, id: string, body?: DuplicateHybridRequest, observe?: 'body', reportProgress?: boolean): Observable<WorkflowDefinition>;
    public duplicateHybridRuleset(projectId: number, id: string, body?: DuplicateHybridRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WorkflowDefinition>>;
    public duplicateHybridRuleset(projectId: number, id: string, body?: DuplicateHybridRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WorkflowDefinition>>;
    public duplicateHybridRuleset(projectId: number, id: string, body?: DuplicateHybridRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling duplicateHybridRuleset.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling duplicateHybridRuleset.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<WorkflowDefinition>('post',`${this.basePath}/workflows/definitions/${encodeURIComponent(String(id))}/duplicate-hybrid`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param shareId 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public duplicateSharedMyCheck(shareId: string, projectId: number, observe?: 'body', reportProgress?: boolean): Observable<WorkflowDefinition>;
    public duplicateSharedMyCheck(shareId: string, projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WorkflowDefinition>>;
    public duplicateSharedMyCheck(shareId: string, projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WorkflowDefinition>>;
    public duplicateSharedMyCheck(shareId: string, projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (shareId === null || shareId === undefined) {
            throw new Error('Required parameter shareId was null or undefined when calling duplicateSharedMyCheck.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling duplicateSharedMyCheck.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<WorkflowDefinition>('post',`${this.basePath}/workflows/definitions/shared/${encodeURIComponent(String(shareId))}/duplicate`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param projectId 
     * @param ids 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findUsages(projectId: number, ids: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<MyCheckUsage>>;
    public findUsages(projectId: number, ids: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MyCheckUsage>>>;
    public findUsages(projectId: number, ids: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MyCheckUsage>>>;
    public findUsages(projectId: number, ids: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling findUsages.');
        }

        if (ids === null || ids === undefined) {
            throw new Error('Required parameter ids was null or undefined when calling findUsages.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }
        if (ids) {
            ids.forEach((element) => {
                queryParameters = queryParameters.append('ids', <any>element);
            })
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<MyCheckUsage>>('get',`${this.basePath}/workflows/definitions/usages`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDefinition(id: string, projectId: number, observe?: 'body', reportProgress?: boolean): Observable<WorkflowDefinition>;
    public getDefinition(id: string, projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WorkflowDefinition>>;
    public getDefinition(id: string, projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WorkflowDefinition>>;
    public getDefinition(id: string, projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getDefinition.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getDefinition.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<WorkflowDefinition>('get',`${this.basePath}/workflows/definitions/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param slug 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDefinitionBySlug(slug: string, observe?: 'body', reportProgress?: boolean): Observable<WorkflowDefinition>;
    public getDefinitionBySlug(slug: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WorkflowDefinition>>;
    public getDefinitionBySlug(slug: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WorkflowDefinition>>;
    public getDefinitionBySlug(slug: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (slug === null || slug === undefined) {
            throw new Error('Required parameter slug was null or undefined when calling getDefinitionBySlug.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<WorkflowDefinition>('get',`${this.basePath}/workflows/definitions/by-slug/${encodeURIComponent(String(slug))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listAvailableDefinitions(projectId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<WorkflowDefinition>>;
    public listAvailableDefinitions(projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<WorkflowDefinition>>>;
    public listAvailableDefinitions(projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<WorkflowDefinition>>>;
    public listAvailableDefinitions(projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling listAvailableDefinitions.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<WorkflowDefinition>>('get',`${this.basePath}/workflows/definitions/available`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param projectId 
     * @param definitionType 
     * @param includeArchived 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listDefinitions(projectId?: number, definitionType?: string, includeArchived?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<WorkflowDefinition>>;
    public listDefinitions(projectId?: number, definitionType?: string, includeArchived?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<WorkflowDefinition>>>;
    public listDefinitions(projectId?: number, definitionType?: string, includeArchived?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<WorkflowDefinition>>>;
    public listDefinitions(projectId?: number, definitionType?: string, includeArchived?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }
        if (definitionType !== undefined && definitionType !== null) {
            queryParameters = queryParameters.set('definitionType', <any>definitionType);
        }
        if (includeArchived !== undefined && includeArchived !== null) {
            queryParameters = queryParameters.set('includeArchived', <any>includeArchived);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<WorkflowDefinition>>('get',`${this.basePath}/workflows/definitions`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listMissingRulesetsForDuplicate(id: string, projectId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ReferencedRulesetDto>>;
    public listMissingRulesetsForDuplicate(id: string, projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ReferencedRulesetDto>>>;
    public listMissingRulesetsForDuplicate(id: string, projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ReferencedRulesetDto>>>;
    public listMissingRulesetsForDuplicate(id: string, projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling listMissingRulesetsForDuplicate.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling listMissingRulesetsForDuplicate.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ReferencedRulesetDto>>('get',`${this.basePath}/workflows/definitions/${encodeURIComponent(String(id))}/duplicate/missing-rulesets`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listSharedMyChecks(projectId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<SharedMyCheckDto>>;
    public listSharedMyChecks(projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SharedMyCheckDto>>>;
    public listSharedMyChecks(projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SharedMyCheckDto>>>;
    public listSharedMyChecks(projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling listSharedMyChecks.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SharedMyCheckDto>>('get',`${this.basePath}/workflows/definitions/shared`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public proposeMyCheckFeatureRequest(body: MyCheckFeatureProposalRequest, projectId: number, observe?: 'body', reportProgress?: boolean): Observable<MyCheckFeatureProposal>;
    public proposeMyCheckFeatureRequest(body: MyCheckFeatureProposalRequest, projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MyCheckFeatureProposal>>;
    public proposeMyCheckFeatureRequest(body: MyCheckFeatureProposalRequest, projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MyCheckFeatureProposal>>;
    public proposeMyCheckFeatureRequest(body: MyCheckFeatureProposalRequest, projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling proposeMyCheckFeatureRequest.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling proposeMyCheckFeatureRequest.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<MyCheckFeatureProposal>('post',`${this.basePath}/workflows/definitions/mycheck/feature-request/proposal`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public restoreDefinition(id: string, projectId: number, observe?: 'body', reportProgress?: boolean): Observable<WorkflowDefinition>;
    public restoreDefinition(id: string, projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WorkflowDefinition>>;
    public restoreDefinition(id: string, projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WorkflowDefinition>>;
    public restoreDefinition(id: string, projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling restoreDefinition.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling restoreDefinition.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<WorkflowDefinition>('post',`${this.basePath}/workflows/definitions/${encodeURIComponent(String(id))}/restore`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public seedIdsCheck(observe?: 'body', reportProgress?: boolean): Observable<WorkflowDefinition>;
    public seedIdsCheck(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WorkflowDefinition>>;
    public seedIdsCheck(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WorkflowDefinition>>;
    public seedIdsCheck(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<WorkflowDefinition>('post',`${this.basePath}/workflows/definitions/seed/ids-check`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public submitMyCheckFeatureRequest(body: MyCheckFeatureRequestRequest, projectId: number, observe?: 'body', reportProgress?: boolean): Observable<{ [key: string]: string; }>;
    public submitMyCheckFeatureRequest(body: MyCheckFeatureRequestRequest, projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<{ [key: string]: string; }>>;
    public submitMyCheckFeatureRequest(body: MyCheckFeatureRequestRequest, projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<{ [key: string]: string; }>>;
    public submitMyCheckFeatureRequest(body: MyCheckFeatureRequestRequest, projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling submitMyCheckFeatureRequest.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling submitMyCheckFeatureRequest.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<{ [key: string]: string; }>('post',`${this.basePath}/workflows/definitions/mycheck/feature-request`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param projectId 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateDefinition(body: CreateWorkflowRequest, projectId: number, id: string, observe?: 'body', reportProgress?: boolean): Observable<WorkflowDefinition>;
    public updateDefinition(body: CreateWorkflowRequest, projectId: number, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WorkflowDefinition>>;
    public updateDefinition(body: CreateWorkflowRequest, projectId: number, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WorkflowDefinition>>;
    public updateDefinition(body: CreateWorkflowRequest, projectId: number, id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateDefinition.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling updateDefinition.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateDefinition.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<WorkflowDefinition>('put',`${this.basePath}/workflows/definitions/${encodeURIComponent(String(id))}`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param projectId 
     * @param rulesetId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public upsertAutoDefinitionForRuleset(body: CreateWorkflowRequest, projectId: number, rulesetId: string, observe?: 'body', reportProgress?: boolean): Observable<WorkflowDefinition>;
    public upsertAutoDefinitionForRuleset(body: CreateWorkflowRequest, projectId: number, rulesetId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WorkflowDefinition>>;
    public upsertAutoDefinitionForRuleset(body: CreateWorkflowRequest, projectId: number, rulesetId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WorkflowDefinition>>;
    public upsertAutoDefinitionForRuleset(body: CreateWorkflowRequest, projectId: number, rulesetId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling upsertAutoDefinitionForRuleset.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling upsertAutoDefinitionForRuleset.');
        }

        if (rulesetId === null || rulesetId === undefined) {
            throw new Error('Required parameter rulesetId was null or undefined when calling upsertAutoDefinitionForRuleset.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }
        if (rulesetId !== undefined && rulesetId !== null) {
            queryParameters = queryParameters.set('rulesetId', <any>rulesetId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<WorkflowDefinition>('put',`${this.basePath}/workflows/definitions/auto-for-ruleset`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param projectId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public validateManifest(body: CreateWorkflowRequest, projectId: number, observe?: 'body', reportProgress?: boolean): Observable<{ [key: string]: any; }>;
    public validateManifest(body: CreateWorkflowRequest, projectId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<{ [key: string]: any; }>>;
    public validateManifest(body: CreateWorkflowRequest, projectId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<{ [key: string]: any; }>>;
    public validateManifest(body: CreateWorkflowRequest, projectId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling validateManifest.');
        }

        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling validateManifest.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (projectId !== undefined && projectId !== null) {
            queryParameters = queryParameters.set('projectId', <any>projectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<{ [key: string]: any; }>('post',`${this.basePath}/workflows/definitions/validate`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
